'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _regeneratorRuntime = _interopDefault(require('@babel/runtime/regenerator'));
var _defineProperty = _interopDefault(require('@babel/runtime/helpers/defineProperty'));
var _asyncToGenerator = _interopDefault(require('@babel/runtime/helpers/asyncToGenerator'));
var _omit = _interopDefault(require('lodash/fp/omit'));
var md5 = _interopDefault(require('md5'));
var R = require('ramda');
var ramdaAdjunct = require('ramda-adjunct');
var yup = require('yup');

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { keys.push.apply(keys, Object.getOwnPropertySymbols(object)); } if (enumerableOnly) keys = keys.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { if (i % 2) { var source = arguments[i] != null ? arguments[i] : {}; ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(arguments[i])); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(arguments[i], key)); }); } } return target; }
var baseValidations = {
  repositoryName: yup.string().nullable().required(),
  accessToken: yup.string().nullable().required(),
  linkResolver: yup.mixed().test('is function', '${path} is not a function', ramdaAdjunct.isFunction).default(function () {
    return ramdaAdjunct.noop;
  }),
  fetchLinks: yup.array().of(yup.string().required()).default([]),
  htmlSerializer: yup.mixed().test('is function', '${path} is not a function', ramdaAdjunct.isFunction).default(function () {
    return ramdaAdjunct.noop;
  }),
  schemas: yup.object().nullable().required(),
  lang: yup.string().nullable().default('*'),
  shouldNormalizeImage: yup.mixed().test('is function', '${path} is not a function', ramdaAdjunct.isFunction).default(function () {
    return R.always(true);
  }),
  plugins: yup.array().max(0).default([])
};
var validatePluginOptions = function validatePluginOptions(pluginOptions) {
  var requireSchemas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var schema = yup.object().shape(_objectSpread({}, baseValidations, {
    schemas: requireSchemas ? baseValidations.schemas : undefined,
    typePathsFilenamePrefix: yup.string().nullable().default("prismic-typepaths---".concat(pluginOptions.repositoryName, "-"))
  }));
  return schema.validate(pluginOptions, {
    abortEarly: false
  });
};

var IS_BROWSER = typeof window !== 'undefined';
var GLOBAL_STORE_KEY = '___PRISMIC___';

var onClientEntry =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee(_, rawPluginOptions) {
    var searchParams, isPreviewSession, pluginOptions, schemasDigest;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (IS_BROWSER) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return");

          case 2:
            searchParams = new URLSearchParams(window.location.search);
            isPreviewSession = searchParams.has('token') && searchParams.has('documentId');

            if (!isPreviewSession) {
              _context.next = 10;
              break;
            }

            _context.next = 7;
            return validatePluginOptions(_omit(['schemas', 'plugins'], rawPluginOptions), false);

          case 7:
            pluginOptions = _context.sent;
            schemasDigest = md5(JSON.stringify(rawPluginOptions.schemas));
            window[GLOBAL_STORE_KEY] = _defineProperty({}, rawPluginOptions.repositoryName, {
              pluginOptions: pluginOptions,
              schemasDigest: schemasDigest
            });

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function onClientEntry(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.onClientEntry = onClientEntry;
//# sourceMappingURL=gatsby-browser.js.map
